export default {};
//# sourceMappingURL=AppBar.js.map